import React, { FC } from 'react';

import { formatOption }                            from '../../../../util';
import { PreSelectedSelectField }                  from '../../../../types';
import { OBJECTIVE_STATUS, OBJECTIVE_STATUS_INFO } from '../../../../constants/ProductEnums';
import { SelectField }                             from '../../../components/forms';
import { useProjectTermDictionary }                from '../../../../hooks/useTermDictionary';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let { getTerm } = useProjectTermDictionary();
	
	let options = [
		formatOption( OBJECTIVE_STATUS.NOT_STARTED, getTerm( OBJECTIVE_STATUS_INFO.NOT_STARTED.LABEL ) ),
		formatOption( OBJECTIVE_STATUS.IN_PROGRESS_LOW, getTerm( OBJECTIVE_STATUS_INFO.IN_PROGRESS_LOW.LABEL ) ),
		formatOption( OBJECTIVE_STATUS.IN_PROGRESS_MED, getTerm( OBJECTIVE_STATUS_INFO.IN_PROGRESS_MED.LABEL ) ),
		formatOption( OBJECTIVE_STATUS.IN_PROGRESS_HIGH, getTerm( OBJECTIVE_STATUS_INFO.IN_PROGRESS_HIGH.LABEL ) ),
		formatOption( OBJECTIVE_STATUS.COMPLETE, getTerm( OBJECTIVE_STATUS_INFO.COMPLETE.LABEL ) ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as ObjectiveStatusDropdown };
